module.exports = __webpack_public_path__ + "img/empty.8bc2e5c8.png";